import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-d55aa7b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = ["src"]




export default /*#__PURE__*/_defineComponent({
  __name: 'CardComponent',
  props: {
    class:{
        type:String,
        require:true
    },
    image:{
        type: String,
        require: true
    },
    title:{
        type: String,
        required: true
    },
    content:{
        type: String,
        required: true
    },
    
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(props.class)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: props.image,
        alt: "Card Image"
      }, null, 8, _hoisted_2),
      _createElementVNode("div", null, [
        _createElementVNode("h3", null, _toDisplayString(props.title), 1),
        _createElementVNode("p", null, _toDisplayString(props.content), 1)
      ])
    ])
  ], 2))
}
}

})